import React from 'react';
import './App.scss';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import HomePage from "../Pages/HomePage/HomePage";
import ChoixPortePage from "../Pages/ChoixPortePage/ChoixPortePage";
import ChoixSiegePage from "../Pages/ChoixSiegePage/ChoixSiegePage";
import MenuPage from "../Pages/MenuPage/MenuPage";
import ItemPage from "../Pages/ItemPage/ItemPage";
import PanierPage from "../Pages/PanierPage/PanierPage";
import CommandePage from "../Pages/CommandePage/CommandePage";
import PaiementPage from "../Pages/PaiementPage/PaiementPage";
import AjoutCartePage from "../Pages/AjoutCartePage/AjoutCartePage";
import QrCodePage from "../Pages/QrCodePage/QrCodePage";
import HistoriquePage from "../Pages/HistoriquePage/HistoriquePage";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import StandsPage from "../Pages/StandsPage/StandsPage";
import ResetPasswordPage from "../Pages/ResetPasswordPage/ResetPasswordPage";
import store from "../store";
import {PersistGate} from "redux-persist/integration/react";
import StadePage from "../Pages/StadePage/StadePage";
import EdenredCallbackPage from "../Pages/EdenredCallbackPage/EdenredCallbackPage";
import {useTranslation} from "react-i18next";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY || '');

const App: React.FC = () => {
    const {i18n} = useTranslation()

    return (
        <>
            <PersistGate loading={null} persistor={store.persistor}>
                <Elements key={i18n.language} stripe={stripePromise} options={{locale: i18n.language as any}}>
                    <BrowserRouter basename={process.env.PUBLIC_URL}>
                        <Routes>
                            <Route path={'/'} element={<HomePage/>}/>
                            <Route path={'/:stadium'} element={<StadePage/>}/>
                            <Route path={'/choixporte'} element={<ChoixPortePage/>}/>
                            <Route path={'/choixsiege'} element={<ChoixSiegePage/>}/>
                            <Route path={'/stands'} element={<StandsPage/>}/>
                            <Route path={'/menu'} element={<MenuPage/>}/>
                            <Route path={'/produit'} element={<ItemPage/>}/>
                            <Route path={'/panier'} element={<PanierPage/>}/>
                            <Route path={'/commande'} element={<CommandePage/>}/>
                            <Route path={'/paiement'} element={<PaiementPage/>}/>
                            <Route path={'/ajout-carte'} element={<AjoutCartePage/>}/>
                            <Route path={'/qrCode'} element={<QrCodePage/>}/>
                            <Route path={'/historique'} element={<HistoriquePage/>}/>
                            <Route path={'/reset-password'} element={<ResetPasswordPage/>}/>
                            <Route path={'/edenred-callback'} element={<EdenredCallbackPage/>}/>
                        </Routes>
                    </BrowserRouter>
                </Elements>
            </PersistGate>
        </>
    );
};

export default App;
